<template>
  <div class="firstclassifi">
    <div class="firstclassifi-div">
      <div class="firstclassifi-div-first">
        <div class="firstclassifi-div-first-addition" @click="additionClick">
          <img
            class="first-addition-img"
            src="../../assets/common/common-add.png"
          />
          <div class="first-addition-title">添加</div>
        </div>
      </div>
      <div class="firstclassifi-div-second">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column
            prop="name"
            label="一级分类"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="二级分类"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="commondityName"
            label="商品名称"
          ></el-table-column>
          <el-table-column label="商品图片" width="80">
            <template slot-scope="scope">
              <div class="table-cover">
                <img class="table-cover-img" :src="scope.row.img" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售价" width="100">
            <template slot-scope="scope">
              <span>¥</span> {{ scope.row.selling }}
            </template>
          </el-table-column>
          <el-table-column label="划线价" width="100">
            <template slot-scope="scope">
              <span>¥</span> {{ scope.row.lintPrize }}
            </template>
          </el-table-column>
          <el-table-column label="商品状态" width="140">
            <template slot-scope="scope">
              {{ scope.row.commondityStatus == '0' ? '展示中' : '隐藏' }}
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序" width="100">
            <template slot-scope="scope">
              <div class="table-sort">
                <img
                  class="table-sort-left"
                  :src="
                    scope.row.size == false
                      ? require('../../assets/marketing/marketing-forbid-up.png')
                      : require('../../assets/marketing/marketing-up.png')
                  "
                  alt=""
                />
                <img
                  class="table-sort-right"
                  :src="
                    scope.row.size1 == false
                      ? require('../../assets/marketing/marketing-forbid-below.png')
                      : require('../../assets/marketing/marketing-below.png')
                  "
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="150">
            <template slot-scope="scope">
              <div class="operation">
                <div class="compile" @click="compileBtn(scope.row)">编辑</div>

                <div class="delete" @click="deteleBtn(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--一级分类  添加弹出框-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        width="444px"
        style="margin-top: 15vh"
        :show-close="false"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="div-top-title">
                {{ compileShow == false ? '商品添加' : '商品编辑' }}
              </div>
              <img class="div-top-close" src="../../assets/common/close.png" />
            </div>

            <div class="addition-div-center">
              <div class="center-title">商品名称</div>
              <div class="center-input">
                <el-autocomplete
                  class="inline-input"
                  v-model="suggestValue"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  clearable
                ></el-autocomplete>
              </div>
              <div class="center-title">商品id</div>
              <div class="center-select">
                <el-select v-model="additionType" placeholder="请选择">
                  <el-option
                    v-for="item in additionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="center-display">
                <div class="center-display-left">
                  <div class="center-display-left-title">划线价</div>
                  <div class="center-display-left-input">
                    <el-input
                      placeholder="选填"
                      v-model="lintPrize"
                      class="input-with-select"
                    >
                      <div class="input-append" slot="append">元</div>
                    </el-input>
                  </div>
                </div>
                <div class="center-display-right">
                  <div class="center-display-right-title">状态</div>
                  <div class="center-display-right-check">
                    <div class="center-display-right-check-show">
                      <el-radio v-model="additionRadio" label="1"
                        >展示</el-radio
                      >
                    </div>
                    <div class="center-display-check-right-conceal">
                      <el-radio v-model="additionRadio" label="2"
                        >隐藏</el-radio
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="addition-div-button">
              <div class="addition-div-button-reset">重置</div>
              <div class="addition-div-button-confirm">确定</div>
            </div>
          </div>
        </span></el-dialog
      >
    </div>

        <!-- 第二区域  删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">请重新确定是否删除？</div>
            <div class="detele-div-text">
              一旦确定后，则删除该一级分类，包括关联的商品和二级分类也将删除。
            </div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 第二模块 表格数组数据
      tableData: [
        {
          name: '每日新品',
          title: '',
          commondityName: '不理解人，就无法理解什么是设计',
          img: require('../../assets/activities/activities-simulation.png'),
          selling: '676',
          lintPrize: '387',
          commondityStatus: '0',
          size: true, // true 表示置顶
          size1: false, // true 表示置底
        },
        {
          name: '精品推荐',
          title: '',
          commondityName: '不理解人，就无法理解什么是设计',
          img: require('../../assets/activities/activities-simulation.png'),
          selling: '676',
          lintPrize: '387',
          commondityStatus: '1',
          size: false, // true 表示置顶
          size1: true, // true 表示置底
        },
      ],

      // 添加弹出框区域
      additionDialogVisible: false,
      // 添加弹出框  带建议搜索框数组
      restaurants: [],
      // 添加弹出框  带建议搜索框数组
      suggestValue: '',
      // 添加弹出框   选择器
      additionList: [
        {
          value: '0',
          label: '选项1',
        },
        {
          value: '1',
          label: '选项1',
        },
        {
          value: '2',
          label: '选项1',
        },
      ],
      // 添加弹出框 选中
      additionType: '',
      // 添加弹出框  划线价  选填
      lintPrize: '',
      // 添加弹出框 单选
      additionRadio: '1',
      // end

      // 商品区域 编辑区域  判断用户是从编辑点击区域进入
      compileShow: false,
      /* 删除弹出框 */
      deteleDialogVisible: false,
    }
  },
  created() {},
  mounted() {
    this.restaurants = this.loadAll()
  },
  methods: {
    // 用户点击添加按钮开启弹出框
    additionClick() {
      this.compileShow = false
      this.additionDialogVisible = true
    },
    // 添加 带建议搜索
    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    loadAll() {
      return [
        { value: '三全鲜食（北新泾店）', address: '长宁区新渔路144号' },
        {
          value: 'Hot honey 首尔炸鸡（仙霞路）',
          address: '上海市长宁区淞虹路661号',
        },
        {
          value: '新旺角茶餐厅',
          address: '上海市普陀区真北路988号创邑金沙谷6号楼113',
        },
        { value: '泷千家(天山西路店)', address: '天山西路438号' },
        {
          value: '胖仙女纸杯蛋糕（上海凌空店）',
          address: '上海市长宁区金钟路968号1幢18号楼一层商铺18-101',
        },
        { value: '贡茶', address: '上海市长宁区金钟路633号' },
        {
          value: '豪大大香鸡排超级奶爸',
          address: '上海市嘉定区曹安公路曹安路1685号',
        },
        {
          value: '茶芝兰（奶茶，手抓饼）',
          address: '上海市普陀区同普路1435号',
        },
        { value: '十二泷町', address: '上海市北翟路1444弄81号B幢-107' },
        { value: '星移浓缩咖啡', address: '上海市嘉定区新郁路817号' },
        { value: '阿姨奶茶/豪大大', address: '嘉定区曹安路1611号' },
        { value: '新麦甜四季甜品炸鸡', address: '嘉定区曹安公路2383弄55号' },
        {
          value: 'Monica摩托主题咖啡店',
          address: '嘉定区江桥镇曹安公路2409号1F，2383弄62号1F',
        },
        {
          value: '浮生若茶（凌空soho店）',
          address: '上海长宁区金钟路968号9号楼地下一层',
        },
        { value: 'NONO JUICE  鲜榨果汁', address: '上海市长宁区天山西路119号' },
        { value: 'CoCo都可(北新泾店）', address: '上海市长宁区仙霞西路' },
        {
          value: '快乐柠檬（神州智慧店）',
          address: '上海市长宁区天山西路567号1层R117号店铺',
        },
        {
          value: 'Merci Paul cafe',
          address: '上海市普陀区光复西路丹巴路28弄6号楼819',
        },
        {
          value: '猫山王（西郊百联店）',
          address: '上海市长宁区仙霞西路88号第一层G05-F01-1-306',
        },
        { value: '枪会山', address: '上海市普陀区棕榈路' },
        { value: '纵食', address: '元丰天山花园(东门) 双流路267号' },
        { value: '钱记', address: '上海市长宁区天山西路' },
        { value: '壹杯加', address: '上海市长宁区通协路' },
        {
          value: '唦哇嘀咖',
          address: '上海市长宁区新泾镇金钟路999号2幢（B幢）第01层第1-02A单元',
        },
        { value: '爱茜茜里(西郊百联)', address: '长宁区仙霞西路88号1305室' },
        {
          value: '爱茜茜里(近铁广场)',
          address:
            '上海市普陀区真北路818号近铁城市广场北区地下二楼N-B2-O2-C商铺',
        },
        {
          value: '鲜果榨汁（金沙江路和美广店）',
          address: '普陀区金沙江路2239号金沙和美广场B1-10-6',
        },
        {
          value: '开心丽果（缤谷店）',
          address: '上海市长宁区威宁路天山路341号',
        },
        { value: '超级鸡车（丰庄路店）', address: '上海市嘉定区丰庄路240号' },
        { value: '妙生活果园（北新泾店）', address: '长宁区新渔路144号' },
        { value: '香宜度麻辣香锅', address: '长宁区淞虹路148号' },
        {
          value: '凡仔汉堡（老真北路店）',
          address: '上海市普陀区老真北路160号',
        },
        { value: '港式小铺', address: '上海市长宁区金钟路968号15楼15-105室' },
        { value: '蜀香源麻辣香锅（剑河路店）', address: '剑河路443-1' },
        { value: '北京饺子馆', address: '长宁区北新泾街道天山西路490-1号' },
        {
          value: '饭典*新简餐（凌空SOHO店）',
          address: '上海市长宁区金钟路968号9号楼地下一层9-83室',
        },
        {
          value: '焦耳·川式快餐（金钟路店）',
          address: '上海市金钟路633号地下一层甲部',
        },
        { value: '动力鸡车', address: '长宁区仙霞西路299弄3号101B' },
        { value: '浏阳蒸菜', address: '天山西路430号' },
        { value: '四海游龙（天山西路店）', address: '上海市长宁区天山西路' },
        {
          value: '樱花食堂（凌空店）',
          address: '上海市长宁区金钟路968号15楼15-105室',
        },
        { value: '壹分米客家传统调制米粉(天山店)', address: '天山西路428号' },
        {
          value: '福荣祥烧腊（平溪路店）',
          address: '上海市长宁区协和路福泉路255弄57-73号',
        },
        {
          value: '速记黄焖鸡米饭',
          address: '上海市长宁区北新泾街道金钟路180号1层01号摊位',
        },
        { value: '红辣椒麻辣烫', address: '上海市长宁区天山西路492号' },
        {
          value: '(小杨生煎)西郊百联餐厅',
          address: '长宁区仙霞西路88号百联2楼',
        },
        { value: '阳阳麻辣烫', address: '天山西路389号' },
        {
          value: '南拳妈妈龙虾盖浇饭',
          address: '普陀区金沙江路1699号鑫乐惠美食广场A13',
        },
      ]
    },
    handleSelect(item) {
      console.log(item)
    },
    /*end */

    // 商品列表区域
    compileBtn(e) {
      this.compileShow = true
      this.suggestValue = '苹果手机'
      this.additionType = '234'
      this.lintPrize = ''
      this.additionRadio = '2'

      this.$nextTick(() => {
        this.additionDialogVisible = true
      })
    },
      /* 删除 */
    // 开启删除弹出框
    deteleBtn(e) {
      this.deteleDialogVisible = true
    },
    // 确定删除框
    confirmDetele() {
      this.deteleDialogVisible = false
    },

    // 取消删除弹出框
    cancelDetele() {
      this.deteleDialogVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.firstclassifi {
  background: #ffffff;
  height: 100%;
  .firstclassifi-div {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    .firstclassifi-div-first {
      height: 80px;
      display: flex;
      align-items: center;

      .firstclassifi-div-first-addition {
        width: 82px;
        height: 36px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .first-addition-img {
          width: 13px;
          height: 13px;
        }

        .first-addition-title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }

    .firstclassifi-div-second {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }
      .table-cover {
        width: 70;
        height: 70px;
        .table-cover-img {
          width: 70;
          height: 70px;
          background: #e9edf4;
          border-radius: 5px;
        }
      }

      .table-status {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
      }

      .table-set {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 26px;
          height: 26px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        .delete {
          margin-left: 24px;
        }
      }
    }
  }

  .addition {
    /deep/ .el-dialog {
      height: 350px;
    }
    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }
    .addition-div {
      .addition-div-top {
        display: flex;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9edf4;

        .div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .div-top-close {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        .center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-input {
          width: 100%;
          height: 32px;
          margin-top: 4px;
          margin-bottom: 16px;
          /deep/ .el-autocomplete {
            width: 100%;
          }

          /deep/ .el-input {
            width: 100%;
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }

        .center-select {
          margin-top: 4px;
          width: 100%;
          height: 32px;
          /deep/ .el-select {
            width: 100%;
          }

          /deep/ .el-input--suffix .el-input__inner {
            height: 32px;
          }

          /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: rgba(217, 217, 217, 1);
          }
        }

        .center-display {
          display: flex;
          margin-top: 14px;
          .center-display-left {
            .center-display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .center-display-left-input {
              width: 208px;
              margin-top: 4px;
              /deep/ .el-input {
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-input-group__append {
                background-color: #ffffff;
                height: 32px;
                padding: 0;
              }
              .input-append {
                width: 38px;
                height: 30px;
                background: #ffffff;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
              }
            }
          }

          .center-display-right {
            margin-left: 52px;
            .center-display-right-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .center-display-right-check {
              display: flex;
              margin-top: 9px;

              .center-display-right-check-show,
              .center-display-check-right-conceal {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #222222;
              }

              .center-display-check-right-conceal {
                margin-left: 28px;
              }
            }
          }
        }
      }

      .addition-div-button {
        display: flex;
        height: 52px;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 22px;
        border-top: 1px solid #e9edf4;

        .addition-div-button-reset,
        .addition-div-button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          cursor: pointer;
        }

        .addition-div-button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }


  /* 右侧删除弹出框 */
  .detele {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .detele-div {
      width: 100%;
      text-align: center;
      padding-top: 25px;
      .detele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .detele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }

      .detele-div-text {
        width: 319px;
        height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin: 0 auto;
        margin-top: 2px;
      }

      .detele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .detele-div-button-left,
        .detele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .detele-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
